import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  Alert,
} from '@mui/material';
import { Cancel, Receipt, Home, CreditCard } from '@mui/icons-material';

const PaymentCancelPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const factureId = searchParams.get('factureId');

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper
        sx={{
          p: 4,
          textAlign: 'center',
          background: 'linear-gradient(135deg, #FFEBEE 0%, #FCE4EC 100%)',
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            bgcolor: '#F44336',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
          }}
        >
          <Cancel sx={{ fontSize: 48, color: 'white' }} />
        </Box>

        <Typography variant="h4" sx={{ fontWeight: 700, mb: 2, color: '#C62828' }}>
          Paiement annulé
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Vous avez annulé le processus de paiement. Aucun montant n'a été débité.
        </Typography>

        <Alert severity="info" sx={{ mb: 3, textAlign: 'left' }}>
          <Typography variant="body2">
            Si vous avez rencontré un problème lors du paiement ou si vous avez des questions,
            n'hésitez pas à nous contacter.
          </Typography>
        </Alert>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          {factureId && (
            <>
              <Button
                variant="contained"
                startIcon={<CreditCard />}
                onClick={() => navigate(`/factures/${factureId}`)}
                sx={{
                  background: 'linear-gradient(135deg, #635BFF 0%, #4F46E5 100%)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #4F46E5 0%, #4338CA 100%)',
                  },
                }}
              >
                Réessayer le paiement
              </Button>
              <Button
                variant="outlined"
                startIcon={<Receipt />}
                onClick={() => navigate(`/factures/${factureId}`)}
              >
                Voir la facture
              </Button>
            </>
          )}
          <Button
            variant="outlined"
            startIcon={<Home />}
            onClick={() => navigate('/')}
          >
            Retour à l'accueil
          </Button>
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ mt: 4, display: 'block' }}>
          Le lien de paiement reste disponible tant que la facture n'est pas payée
        </Typography>
      </Paper>
    </Container>
  );
};

export default PaymentCancelPage;
